
    /**
     * @description
     *  Modelo de un día no-laborable.
     *
     * @see gigot-backend/Models/Configuration/Holiday.cs
     */

export class Holiday {

	public date: Date;
	public description: string;
	public id: number;
	public type: string;

    /**
     * @description
     *	Construye un día no-laborable con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un día con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un día no-laborable vacío.
     */
    public static empty(): Holiday {
        const holiday: Holiday = new Holiday();
		holiday.date = undefined;
		holiday.description = "";
		holiday.id = undefined;
		holiday.type = "";
		return holiday;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicHoliday
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
    public static from(anemicHoliday: Holiday): Holiday {
		if (!anemicHoliday) return undefined;
        const holiday: Holiday = Holiday.empty();
		holiday.date = new Date(anemicHoliday.date);
		holiday.description = anemicHoliday.description;
		holiday.id = anemicHoliday.id;
		holiday.type = anemicHoliday.type;
		return holiday;
    }
}
